// Navigation state for templates/_components/nav.twig, registered in app.js as the
// Alpine component "nav":
//
//   open      the mobile menu is showing
//   dropdown  the "About" menu is showing
//   scrolled  the page is scrolled down: the bar is fixed and white (nav theme "solid")
//   hidden    (only while scrolled) the bar is slid out of view because the visitor is
//             scrolling down; any scroll up brings it back
//   animated  (only while scrolled) the slide may transition; off for a moment when the bar
//             becomes fixed so it doesn't slide in from nowhere
//
// The markup does the rest: it reads these two values for classes and aria attributes.
// Below the `nav` breakpoint (1101px) the menu is the full-screen mobile menu; above it
// the same links sit in the header bar, so any open state is cleared when the window
// grows past it.
const DESKTOP_MIN_WIDTH = 1101;
const SCROLLED_AFTER = 90; // past the height of the bar, so it is already off screen
const TOP = 4; // back to the transparent bar at the very top
const JITTER = 8; // ignore scroll movements smaller than this

export default () => ({
    open: false,
    dropdown: false,
    scrolled: false,
    hidden: false,
    animated: false,
    lastY: 0,
    ticking: false,

    init() {
        this.lastY = window.scrollY;
        this.onScroll();

        // Stop the page scrolling behind the full-screen mobile menu.
        this.$watch('open', (value) => document.body.classList.toggle('overflow-hidden', value));
    },

    toggle() {
        this.open = !this.open;

        if (!this.open) {
            this.dropdown = false;
        }
    },

    closeAll() {
        this.open = false;
        this.dropdown = false;
    },

    onScroll() {
        if (this.ticking) {
            return;
        }

        this.ticking = true;
        requestAnimationFrame(() => {
            this.ticking = false;
            this.update(Math.max(window.scrollY, 0));
        });
    },

    update(y) {
        if (!this.scrolled && y > SCROLLED_AFTER) {
            this.animated = false;
            this.scrolled = true;
            this.hidden = y > this.lastY;
            setTimeout(() => (this.animated = true), 50);
        } else if (this.scrolled && y <= TOP) {
            this.scrolled = false;
            this.hidden = false;
        } else if (this.scrolled && Math.abs(y - this.lastY) >= JITTER) {
            // Never hide while a menu is open or something in the bar has focus.
            this.hidden = y > this.lastY && !this.open && !this.dropdown && !(this.$el.contains(document.activeElement) && document.activeElement.matches(':focus-visible'));
        } else {
            return;
        }

        this.lastY = y;
    },

    onResize() {
        if (window.innerWidth >= DESKTOP_MIN_WIDTH) {
            this.closeAll();
        }
    },
});
